<template>
  <div>
    <h1>Types</h1>
    <v-btn :to="{ name: 'entityTypeAdd' }"> <v-icon>add</v-icon>Type </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="types"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn
              :to="{ name: 'entityType', params: { id: props.item.id } }"
              >{{ props.item.id }}</v-btn
            >
          </td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.contact }}</td>
          <td>{{ props.item.security }}</td>
          <td>{{ props.item.person }}</td>
          <td>{{ props.item.company }}</td>
          <td>{{ props.item.staff }}</td>
          <td>{{ props.item.address }}</td>
          <td>{{ props.item.groups }}</td>
          <td>{{ props.item.employees }}</td>
          <td>{{ props.item.allowMany }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Types",
  metaInfo() {
    return {
      title: "Types",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      types: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Contact",
          value: "contact"
        },
        {
          text: "Security",
          value: "security"
        },
        {
          text: "Person",
          value: "person"
        },
        {
          text: "Company",
          value: "company"
        },
        {
          text: "Staff",
          value: "staff"
        },
        {
          text: "Address",
          value: "address"
        },
        {
          text: "Groups",
          value: "groups"
        },
        {
          text: "Employees",
          value: "employees"
        },
        {
          text: "Allow many",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchTypes() {
      nbmlaw.get(`/cors/admin/directory/types`).then((response) => {
        // console.log(response.data);
        this.types = response.data;
      });
    }
  },
  created() {
    this.fetchTypes();
  }
};
</script>
